
import {forwardRef } from "react"
import './button.component.scss'
import { Loader } from '../';

const Button = forwardRef(function Button({isLoading, disabled = false, className , children, onClick, type='button'}, ref) { 
    return <button  {...{type, ref}}  className={`button-component btn btn-default virgin-button ${className ?? ''} ${disabled ? 'btn-grey' : ''}`} disabled={isLoading || disabled} {...{onClick}}>{children} {isLoading && <Loader className='button-component__loader' />}</button>
})

export default Button;